import { WidgetWithConfigState } from 'widgets/store/configuration/WidgetWithConfigState';
import { WidgetWithComponentState } from 'widgets/store/component/WidgetWithComponentState.ts';
import { OrderVolumeProfileConfiguration } from './configuration/OrderVolumeProfileConfiguration';
import { OrderVolumeProfileComponentState } from './component/OrderVolumeProfileComponentState.ts';

export type OrderVolumeProfileWidgetState =
    WidgetWithConfigState<OrderVolumeProfileConfiguration> &
        WidgetWithComponentState<OrderVolumeProfileComponentState>;

export interface OrderVolumeProfileWidgetsState {
    [widgetId: string]: OrderVolumeProfileWidgetState;
}

export const initialOrderVolumeProfileWidgetsState: OrderVolumeProfileWidgetsState =
    {};
